import type { Layout } from './settings';

export const VIEWS: { layout: Layout; label: string; hint: string }[] = [
  { layout: 'radar', label: 'Radar', hint: 'The 2D radar scope only' },
  { layout: 'split', label: 'Split', hint: 'Radar and tower view side by side' },
  { layout: 'tower', label: 'Tower', hint: 'The 3D view from the tower cab, with strips and radio' },
  { layout: 'pip', label: 'Radar + 3D', hint: 'Radar with a small tower view panel' },
];

export const VIEW_KEYS: Readonly<Record<string, Layout>> = {
  Digit1: 'radar',
  Digit2: 'split',
  Digit3: 'tower',
  Digit4: 'pip',
};

const SPEEDS = [0.5, 0.75, 1, 2, 4, 8, 16];

export const GAME_TEMPLATE = `
<div class="game">
  <header class="g-top">
    <button class="g-btn g-menu" type="button" title="Menu (Esc)">Menu</button>
    <span class="g-icao"></span><span class="g-name"></span><span class="g-realism"></span>
    <span class="g-ai-wrap"><button class="g-btn g-ai" type="button" aria-expanded="false" aria-controls="g-ai-panel" data-tone="off">AI …</button><div class="g-ai-panel" id="g-ai-panel" role="dialog" aria-label="AI in this session" hidden></div></span>
    <button class="g-btn g-runways" type="button"></button><span class="g-status"></span><span class="g-shift" hidden></span>
    <div class="g-views" role="group" aria-label="Display">${VIEWS.map((v, i) => `<button class="g-btn" type="button" data-view="${v.layout}" title="${v.hint} (Alt+${i + 1})">${v.label}</button>`).join('')}</div>
    <button class="g-btn g-side-toggle" type="button" title="Show or hide strips and radio (Alt+S)">Strips</button>
    <label title="Sim speed"><span class="g-speed-text">Speed</span> <select class="g-speed">${SPEEDS.map((s) => `<option value="${s}">×${s}</option>`).join('')}</select></label>
    <button class="g-btn g-pause" type="button">Pause</button>
    <button class="g-btn g-procs" type="button" title="STARs and approaches on the scope: in use, all, off (Alt+P, PROC)">Procs</button>
    <button class="g-btn g-trail" type="button" title="Selected aircraft's flown track and route ahead (Alt+T, TRAIL)">Trail</button>
    <button class="g-btn g-brief" type="button" title="Charts, runways and procedures (BRIEF)">Briefing</button>
    <button class="g-btn g-fullscreen" type="button" title="Full screen (Alt+F)">Full screen</button>
    <button class="g-btn g-audio" type="button" title="Mute or enable game audio"></button><span class="g-score"></span>
  </header>
  <main class="g-main">
    <div class="g-scope"></div><div class="g-divider" role="separator" aria-orientation="vertical" aria-label="Drag to resize radar and tower view"></div>
    <div class="g-tower" hidden><div class="g-tower-view"></div><button class="g-tower-close" type="button" aria-label="Close tower view">×</button></div>
    <aside class="g-side"><section class="tower-position" hidden></section><h2>Strips</h2><div class="g-strips"></div><h2>Radio</h2><div class="g-comms"></div></aside>
    <section class="g-challenge" hidden aria-live="polite"></section><div class="g-feed" aria-live="polite"></div>
  </main>
  <footer class="g-bottom"><div class="g-hint"></div><div class="g-command"></div><div class="g-voice"></div></footer>
</div>`;
